import { upperFirst } from 'lodash';
import { createSelector } from 'reselect';
import { createHandler } from '@mews/std';
import moduleSelector from '../selector';

const handlerFactory = (baseAction: $TSFixMe) =>
    createHandler(
        {
            [`${baseAction}_STARTED`]: (state: $TSFixMe) => ({
                ...state,
                fetching: true,
            }),

            // @ts-expect-error $TSFixMeError: Parameter 'state' implicitly has an 'any' type.
            [`${baseAction}_SUCCEEDED`]: (state, payload) => ({
                ...payload,
                fetching: false,
            }),

            [`${baseAction}_FAILED`]: (state: $TSFixMe) => ({
                ...state,
                fetching: false,
            }),
        },
        (state) => state
    );

export function reducersFactory({ name, baseAction }: $TSFixMe) {
    const handler = handlerFactory(baseAction);

    const initialState = {
        lastUpdate: 0,
        fetching: false,
        [name]: [],
    };
    return {
        [`${name}Reducer`]: (state: $TSFixMe, action: $TSFixMe) =>
            handler(action.type, state || initialState, action.payload),
    };
}

export function selectorsFactory({ name, entityMapper }: $TSFixMe) {
    const getBaseState = createSelector(moduleSelector, (state) => state[name]);
    const capitalizedName = upperFirst(name);

    return {
        [`get${capitalizedName}State`]: getBaseState,
        [`get${capitalizedName}`]: createSelector(getBaseState, (state) => entityMapper(state[name])),
        isFetching: createSelector(getBaseState, (state) => state.fetching),
        getLastUpdated: createSelector(getBaseState, (state) => state.lastUpdate),
        isLoaded: createSelector(getBaseState, (state) => state.lastUpdate !== 0),
    };
}
